<template>
  <div>
    <el-dialog :visible.sync="innerVisible" :title="title" width="600px" custom-class="cargo-form-dialog" :close-on-click-modal="false" @close="handleClose">
      <el-form ref="form" label-width="100px" label-position="left" class="cargo-form">
        <div class="app-main-inner-row" style="padding: 0;">
          <el-form-item label-width="0">
            <el-button type="primary" no="showCooperateAll" @click="showCooperateAllHandler">{{ $t('CargoMsg.Cargo_ShowCooperateAll') }}</el-button>
          </el-form-item>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item>
              <span slot="label">{{ $t('CargoMsg.Cargo_CooperateBranchId') }}</span>
              <cargo-advance-select
                no="branchId"
                :select-type="TYPE_NAMES.basic_data_Office"
                :clearable="false"
                filterable
                :default-value="Number(job.branchId)"
                :cache="false"
                :static-options="officeList"
                :placeholder="' '"
                :disabled="!editable"
                @parentCallBack="p=>{job.branchId=p.value}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span slot="label">{{ $t('CargoMsg.Cargo_CooperateBusinessType') }}</span>
              <cargo-advance-select
                no="businessType"
                :select-type="TYPE_NAMES.basic_data_CooperationType"
                :multiple="true"
                :clearable="false"
                filterable
                :default-multiple-value="job.businessType"
                :placeholder="' '"
                :disabled="!editable"
                @parentCallBack="p=>{job.businessType=p.value}"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.Operation') }}</span>
              <cargo-user-select
                no="opId"
                :method-params="{officeId:job.branchId,category:'role',shape:'op'}"
                :default-value="job.opId||''"
                :placeholder="' '"
                :disabled="!editable"
                @change="p=>{job.opId=p.value}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                no="csrId"
                :method-params="{officeId:job.branchId,category:'role',shape:'csr'}"
                :default-value="job.csrId||''"
                :placeholder="' '"
                :disabled="!editable"
                @change="p=>{job.csrId=p.value}"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                no="overseaOp"
                :method-params="{officeId:job.branchId,category:'role',shape:'overseaOp'}"
                :default-value="job.overseaOp||''"
                :placeholder="' '"
                :disabled="!editable"
                @change="p=>{job.overseaOp=p.value}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select
                no="planner"
                :method-params="{officeId:job.branchId,category:'role',shape:'doc'}"
                :default-value="job.dcId||''"
                :placeholder="' '"
                :disabled="!editable"
                @change="p=>{job.dcId=p.value}"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item v-if="isSeaExport" :label="$t('SeaExport.BookingAgent')">
              <cargo-advance-select
                no="bookingAgent"
                :select-type="TYPE_NAMES.basic_data_Company"
                filterable
                :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
                :default-value="seaJob.bookingAgent||''"
                @parentCallBack="p=>{bookingAgentChangeHandler(p)}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="isSeaExport" :label="$t('SeaExport.ShippingCompanyContractNo')">
              <el-input v-model="seaJob.scNo" no="scNo" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('SeaExport.AirlinePerson2')">
              <cargo-user-select
                no="planner"
                :method-params="{officeId:job.branchId,category:'role',shape:'seaLine'}"
                :default-value="job.planner||''"
                :placeholder="' '"
                :disabled="!editable"
                @change="p=>{job.planner=p.value}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('SeaExport.Sales')">
              <cargo-user-select
                no="sales"
                :method-params="{officeId:job.branchId,category:'role',shape:'sales'}"
                :default-value="job.sales||''"
                :disabled="true"
                :placeholder="' '"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="cargoSalesId"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="job.cargoSalesId||''"
                :disabled="true"
                :placeholder="' '"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                no="userDefinedRole1"
                :method-params="{officeId:job.branchId,category:'role',shape:'userDefinedRole1'}"
                :default-value="job.userDefinedRoleId1||''"
                :disabled="true"
                :placeholder="' '"
              />&nbsp;
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                no="userDefinedRole2"
                :method-params="{officeId:job.branchId,category:'role',shape:'userDefinedRole2'}"
                :default-value="job.userDefinedRoleId2||''"
                :disabled="true"
                :placeholder="' '"
              />&nbsp;
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input v-model="remark" type="textarea" no="remark" :rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" style="padding:10px;">
        <el-button type="primary" no="confirm" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button no="cancel" @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!--更多协作信息-->
    <cooperation-branch-list
      v-if="cooperationBranchListDialog.visible"
      :visible.sync="cooperationBranchListDialog.visible"
      :job-uuid="cooperationBranchListDialog.jobUuid"
      :job="cooperationBranchListDialog.job"
      :order-center-branch="cooperationBranchListDialog.orderCenterBranch"
      :show-cooperate-all="cooperationBranchListDialog.showCooperateAll"
      @cancel="()=>cooperationBranchListDialog.visible=false"
    />
  </div>
</template>
<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey } from '@/utils/basicDataCache'
import cooperationBranchList from '@/components/Cargo/Job/cooperationBranchList'
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'CooperationVerifyDialog',
  components: { cargoUserSelect, cargoAdvanceSelect, cooperationBranchList },
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true },
    cooperate: { type: Object, default: null },
    submitCallBack: { type: Function, default: () => (null) },
    editable: { type: Boolean, default: false },
    seaJob: { type: Object, default: null },
    config: { type: Map, default: null }
  },
  data() {
    return {
      TYPE_NAMES,
      job: {
        branchId: 0,
        businessType: [],
        opId: 0,
        opDepartment: 0,
        csrId: 0,
        overseaOp: 0,
        dcId: 0,
        planner: 0,
        remark: '',
        sales: 0,
        cargoSalesId: 0,
        userDefinedRoleId1: 0,
        userDefinedRoleId2: 0,
        index: ''
      },
      innerVisible: false,
      officeList: [],
      remark: '',
      cooperationBranchListDialog: {
        visible: false,
        jobUuid: '',
        job: null,
        orderCenterBranch: true,
        showCooperateAll: true
      }
    }
  },
  computed: {
    title() {
      return this.$t('CargoMsg.Cargo_Audit')
    },
    isSeaExport() {
      if (this.seaJob) {
        return this.seaJob.lob === 'SE'
      }
      return false
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          await this.init()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async init() {
      this.officeList = getCacheListByKey(basicCacheKeys.basic_data_Office)
      Object.assign(this.job, this.cooperate)
    },
    handleSubmit() {
      this.submitCallBack(this.remark)
      this.handleClose()
    },
    handleClose() {
      this.remark = ''
      this.innerVisible = false
    },
    showCooperateAllHandler() {
      this.cooperationBranchListDialog.jobUuid = this.jobUuid
      this.cooperationBranchListDialog.job = this.job
      this.cooperationBranchListDialog.visible = true
    },
    // 订舱代理选择
    bookingAgentChangeHandler(event) {
      if (this.seaJob === null) return
      if (!event.value) {
        this.seaJob.bookingAgent = 0
        return
      }
      this.seaJob.bookingAgent = event.value
      if (!this.seaJob.bookingAgent) return
      this.carrierAgentSyncLoading().then(r => {})
    },
    // 是否同步船代、船公司
    async carrierAgentSyncLoading() {
      const company = await Company.getCompanyById(this.seaJob.bookingAgent)
      if (company) {
        if (company.seaCmpAgent) {
          this.seaJob.carrierAgentId = this.seaJob.bookingAgent
        }
        if (!this.seaJob.carrierId && company.seaCmp && this.config && Number(this.config.get('CarrierBookingAgentJoin')) === 1) {
          this.seaJob.carrierId = this.seaJob.bookingAgent
        }
      }
    }
  }
}
</script>
<style lang="scss">
.cargo-form-dialog{
  .el-dialog{
    &__header,&__body,&__footer{
      padding:10px 15px!important;
    }
    &__title{
      vertical-align: middle;
    }
    &__headerbtn{
      top:15px;
      right:15px;
    }
  }
}
.cargo-form{
  .el-form-item {
    &.red-input{
      .el-input__inner{
        color: #E9650E;
      }
    }
    &__content{
      width: auto!important;
    }
    &.label-none {
      .el-form-item__content{
        margin-left: 0;
      }
    }
  }
}
</style>
